import { ArticleType, ApiLinkEntity, ApiLinkRel } from "config/constants"
import { IApiLink, Guid } from "@/types"

export const ARTICLE_MAX_LOWER_LEVEL_ARTICLES = 15

export interface IGetArticleDto {
    id?: Guid
    articleType: ArticleType
    isExtManufacturer: boolean
    manufacturerDescription: string
    manufacturerArticleNo: string
    description: string
    articleNo?: string
    drawingNumber?: string | null
    imageFileId?: Guid | null
    thumbnailUri?: string | null
    imageUri?: string | null
    highLevelArticleNumber?: Guid | null
    lowLevelArticleNumbers?: Guid[] | null
    inspectionRequired: boolean
    sequence?: number | null
    links?: IApiLink[] | null
}

export interface ICreateArticleDto {
    articleType: ArticleType
    isExtManufacturer: boolean
    manufacturerDescription: string
    manufacturerArticleNo: string
    drawingNumber?: string | null
    imageFileId?: Guid
    highLevelArticleNumber?: Guid | null
    lowLevelArticleNumbers?: Guid[] | null
    inspectionRequired?: boolean
    sequence?: number | null
}

export abstract class AbstractArticle {
    abstract create?(): Promise<Guid>
    abstract update?(): Promise<void>
}

export class Article implements AbstractArticle {
    id?: Guid
    articleType: ArticleType
    isExtManufacturer: boolean
    manufacturerDescription: string
    manufacturerArticleNo: string
    description: string
    articleNo?: string
    drawingNumber?: string
    imageFileId?: Guid
    thumbnailUri?: string
    imageUri?: string
    highLevelArticleNumber?: Guid
    lowLevelArticleNumbers: Guid[]
    inspectionRequired: boolean
    sequence?: number | null
    links?: IApiLink[]

    constructor(dto: IGetArticleDto) {
        this.id = dto.id
        this.articleType = dto.articleType
        this.isExtManufacturer = dto.isExtManufacturer
        this.manufacturerDescription = dto.manufacturerDescription
        this.manufacturerArticleNo = dto.manufacturerArticleNo
        this.articleNo = dto.articleNo
        this.description = dto.description
        this.drawingNumber = dto.drawingNumber || undefined
        this.imageFileId = dto.imageFileId || undefined
        this.thumbnailUri = dto.thumbnailUri || undefined
        this.imageUri = dto.imageUri || undefined
        this.highLevelArticleNumber = dto.highLevelArticleNumber || undefined
        this.lowLevelArticleNumbers = dto.lowLevelArticleNumbers || []
        this.inspectionRequired = dto.inspectionRequired
        this.sequence = dto.sequence || undefined
        this.links = dto.links || undefined
    }

    get linkUpdate() {
        return this.links?.find(lnk => lnk.entity === ApiLinkEntity.article && lnk.rel === ApiLinkRel.partialUpdate)
    }

    get linkUpdateInspectionSettings() {
        return this.links?.find(lnk => lnk.entity === ApiLinkEntity.articleInspectionSettings && lnk.rel === ApiLinkRel.update)
    }

    get canUpdate() {
        return !!this.linkUpdate
    }

    async update() {
        if (!this.canUpdate) {
            throw new Error("Update not allowed")
        }
        throw new Error("Update not implemented")
    }
}
